module.exports = __webpack_public_path__ + "static/media/basketball.ccea0be9.png";